import styled from 'styled-components';
import TooltipLabel from '../TooltipLabel/TooltipLabel';

export const ToolTipSmall = styled(TooltipLabel) `
    align-self: center;
    display: inline-block;
    cursor: pointer;

    p {
        margin-bottom: 0px;
        text-transform: uppercase;

        .tooltip-item {
            font-size: 0.9rem;
        }
    }
`


// WEBPACK FOOTER //
// ./src/components/common/TooltipLabel/styled.js